import { render, staticRenderFns } from "./SenseTable.vue?vue&type=template&id=42918018&scoped=true&"
import script from "./SenseTable.vue?vue&type=script&lang=js&"
export * from "./SenseTable.vue?vue&type=script&lang=js&"
import style0 from "./SenseTable.vue?vue&type=style&index=0&id=42918018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42918018",
  null
  
)

export default component.exports